import { lazy, Suspense, useEffect, useState, type ComponentProps } from 'react';

const loadCommunityPanel = () => import('./CommunityPanelImpl');
const CommunityPanelImpl = lazy(loadCommunityPanel);
type CommunityPanelProps = ComponentProps<typeof CommunityPanelImpl>;

/**
 * Keep community/auth/progression code and its first data requests off the
 * critical arcade startup path. A fast PLAY navigation unmounts this boundary
 * before the idle callback, leaving startup capacity to audio, Rapier and 3D.
 */
export default function CommunityPanel(props: CommunityPanelProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let timeoutId: number | undefined;
    let idleId: number | undefined;
    const reveal = () => setReady(true);

    if (window.requestIdleCallback) {
      idleId = window.requestIdleCallback(reveal, { timeout: 900 });
    } else {
      timeoutId = window.setTimeout(reveal, 250);
    }

    return () => {
      if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
      if (timeoutId !== undefined) window.clearTimeout(timeoutId);
    };
  }, []);

  if (!ready) return <section role="status" aria-live="polite">Loading community…</section>;

  return (
    <Suspense fallback={<section role="status" aria-live="polite">Loading community…</section>}>
      <CommunityPanelImpl {...props} />
    </Suspense>
  );
}
